/**
 * @file src/pages/invoice-management-hub/components/BulkActionsDropdown.jsx
 * @description Compact pill showing how many invoices are currently selected.
 *
 * TODO: this is currently a placeholder — clicking does nothing.
 * When bulk actions (delete, export, mark cleared) are implemented,
 * wire them up here and convert this from a Button into a real dropdown menu.
 */

import React from "react";
import Button from "components/ui/Button";

const BulkActionsDropdown = ({ selectedCount }) => (
  <div className="relative">
    <Button variant="outline" size="md" className="border-primary text-primary">
      {selectedCount} selected
    </Button>
  </div>
);

export default BulkActionsDropdown;